import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// serviceWorkerRegistration.register({
//   onUpdate: (registration) => {
//     // 디자인 변경 시 사용자에게 알림
//     if (window.confirm("새로운 버전이 업데이트되었습니다. 최신 디자인으로 갱신할까요?")) {
//       const waitingServiceWorker = registration.waiting;
//       if (waitingServiceWorker) {
//         waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
//       }
//       window.location.reload();
//     }
//   }
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
